(function () {

  'use strict';

  /**
   * @author Ronald Nicholls
   * @class ute-ui.extras
   * @description directive for unified dom structure for terms and conditions
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .directive('uteAcknowledge', function () {

      return {
        restrict: 'EA',
        scope: {
          contentId: '@',
          buttonText: '@',
          checkboxText: '@',
          callback: '&',
          trackingId: '='
        },
        transclude: true,
        template: '<div><ins compile="true" ute-content-injector content-id="{{contentId}}"></ins></div>',
        controller: ['$scope', function ($scope) {

          $scope.accept = function () {
            var foreCallback = $scope.callback() || null;
          };
        }]

      };
    });

})();
